/*
 * Copyright (c) 2021 Mike Vo (info@miketvo.com) - All Rights Reserved.
 *
 * This file is part of the project "miketvo-website".
 *
 * This project is an online personal website by Mike Vo.
 *
 * COPYING AND/OR DISTRIBUTING OF ANY CONTENT WITHIN THIS PROJECT WITHOUT EX-
 * PRESS PERMISSION FROM THE CLIENT AND/OR THE AUTHOR, VIA ANY MEDIUM IS
 * STRICTLY PROHIBITED.
 *
 * Written by Mike Vo on June 27th 2021.
 *
 */

import * as React from "react";
import PropTypes from "prop-types";
import AniLink from "gatsby-plugin-transition-link/AniLink";

import MobileNav from "./mobileNav";
import * as style from "./mainNav.module.css";

const MainNav = ({ lang, langList, navLinks }) => {
  const toggleLangMenu = ev => {
    ev.stopPropagation();
    const langMenu = document.getElementById("main-nav-lang-menu");
    let openStyle =
      "display: -webkit-flex;" +
      "display: -moz-flex;" +
      "display: -ms-flex;" +
      "display: -o-flex;" +
      "display: flex;" +
      "transform-origin: top;" +
      "animation: fadeInExpandY 200ms cubic-bezier(0.22, 1, 0.36, 1);";
    let closeStyle =
      "display: -webkit-flex;" +
      "display: -moz-flex;" +
      "display: -ms-flex;" +
      "display: -o-flex;" +
      "display: flex;" +
      "transform-origin: top;" +
      "animation: fadeOutShrinkY ease-in 300ms;";

    const openLangMenu = () => {
      const closeLangMenu = ev => {
        langMenu.setAttribute("style", closeStyle);
        setTimeout(() => {
          langMenu.removeAttribute("style");
        }, 300);
        document.removeEventListener("click", closeLangMenu);
        window.removeEventListener("keydown", closeLangMenuOnKey);
      };

      const closeLangMenuOnKey = ev => {
        if (ev.code === "Escape") {
          closeLangMenu();
          window.removeEventListener("keydown", closeLangMenuOnKey);
        }
      };

      langMenu.setAttribute("style", openStyle);

      window.addEventListener("keydown", closeLangMenuOnKey);

      document.addEventListener("click", closeLangMenu);
    };

    if (langMenu.getAttribute("style") === null) {
      openLangMenu();
    } else {
      langMenu.removeAttribute("style");
    }
  };

  const openMobileNav = () => {
    let openStyle = "display: block; transform-origin: right; animation: fadeInExpandX 500ms;";
    document.getElementById("mobile-nav").setAttribute("style", openStyle);
  };

  return (
    <nav className={style.wrapper}>
      <ul className={style.desktopOnly}>
        {navLinks.map((link, index) => (
          <li key={["main-nav-", link.link].join()}>
            <AniLink
              cover
              direction="up"
              duration={1}
              bg="var(--light-black)"
              to={link.link}
              className={style.menuLink}
              activeClassName={style.menuLinkActive}
            >
              {link.name}
            </AniLink>
            <img className={style.menuLinkDecorator} src={"/media/nav_indicator_" + (index + 1) + ".svg"} alt="" />
          </li>
        ))}
        <li className={style.langButtonWrapper}>
          <button
            className={style.langButton}
            onClick={ev => {
              toggleLangMenu(ev);
            }}
          >
            <img src={"/media/translate_white_24dp.svg"} alt="" />
          </button>
          <div
            id="main-nav-lang-menu"
            className={style.langMenu}
            onClick={ev => {
              ev.stopPropagation();
            }}
          >
            <div className={style.decorator} />
            <ul>
              {langList.map(langItem => {
                let langPath = langItem.lang + "/";
                if (langPath === "en/") {
                  langPath = "";
                }

                if (lang === langItem.lang) {
                  return (
                    <li className={style.activeLang} key={"main-nav-lang-menu-" + langItem.lang}>
                      <AniLink cover direction="up" duration={1} bg="var(--light-black)" to={"/" + langPath}>
                        {langItem.langName}
                      </AniLink>
                    </li>
                  );
                } else {
                  return (
                    <li key={"main-nav-lang-menu-" + langItem.lang}>
                      <AniLink cover direction="up" duration={1} bg="var(--light-black)" to={"/" + langPath}>
                        {langItem.langName}
                      </AniLink>
                    </li>
                  );
                }
              })}
            </ul>
          </div>
        </li>
      </ul>
      <button
        id="mobile-nav-toggler"
        className={[style.mobileOnly, style.mobileNavToggler].join(" ")}
        onClick={openMobileNav}
      >
        <div />
        <div />
        <div />
      </button>
      <MobileNav id="mobile-nav" lang={lang} langList={langList} navLinks={navLinks} />
    </nav>
  );
};

MainNav.defaultProps = {
  lang: "",
  langList: [],
};

MainNav.propTypes = {
  lang: PropTypes.string,
  langList: PropTypes.array,
  navLinks: PropTypes.array.isRequired,
};

export default MainNav;
